import { rainfallText } from './rain-display'

function shortDate(day) {
  return new Intl.DateTimeFormat('sk-SK', { day: 'numeric', month: 'numeric' }).format(new Date(`${day}T12:00:00`))
}

export default function StationRainTrend({ station }) {
  const rain = station?.rainfall
  if (!rain) return <p className="station-rain-note">14-dňová história tejto stanice nie je dostupná.</p>
  const daily = rain.daily || []
  const maximum = Math.max(10, ...daily.map(day => day.rain_mm ?? 0))
  return (
    <div className="station-rain-trend">
      <div className="station-rain-range">{shortDate(rain.from)} – {shortDate(rain.to)} · {rain.observed_days}/14 dní merané, {rain.estimated_days}/14 odhadované{rain.missing_days > 0 ? `, ${rain.missing_days}/14 chýba` : ''}</div>
      <svg viewBox="0 0 300 105" role="img" aria-label={`Denný trend zrážok pri stanici ${station.name}. Merané a odhadované zrážky sú odlíšené farbou. Podrobné hodnoty sú v tabuľke.`}>
        <text x="2" y="12" className="rain-axis">{maximum.toFixed(1)} mm / deň</text>
        <line x1="0" x2="300" y1="85" y2="85" stroke="#c6cdc5" />
        {daily.map((day, i) => {
          const height = day.rain_mm == null ? 0 : (day.rain_mm / maximum) * 65
          const measured = day.source === 'shmu_observed'
          return <g key={day.date}>
            <title>{shortDate(day.date)}: {rainfallText(day.rain_mm)} · {day.rain_mm == null ? 'chýba' : measured ? 'merané SHMÚ' : 'odhad počasia'}</title>
            {day.rain_mm == null ? <text x={i * 21 + 7} y="80" className="rain-axis">?</text> : <rect x={i * 21 + 3} y={85 - Math.max(1, height)} width="15" height={Math.max(1, height)} fill={measured ? '#508271' : '#a8b3ac'} />}
          </g>
        })}
        {daily.length > 0 && <>
          <text x="2" y="102" className="rain-axis">{shortDate(rain.from)}</text>
          <text x="296" y="102" textAnchor="end" className="rain-axis">{shortDate(rain.to)}</text>
        </>}
      </svg>
      <div className="station-rain-key"><span><i /> Merané SHMÚ</span><span><i className="estimated" /> Odhad počasia</span></div>
      <div className="station-rain-weeks">
        <span>Predošlých 7 dní <b>{rainfallText(rain.previous_7d_mm)}</b></span>
        <span>Posledných 7 dní <b>{rainfallText(rain.recent_7d_mm)}</b></span>
      </div>
      <p className="station-rain-note">{rain.change_mm == null ? 'Na porovnanie týždňov chýbajú údaje.' : `Zmena oproti predošlému týždňu: ${rain.change_mm > 0 ? '+' : ''}${rainfallText(rain.change_mm)}.`}</p>
      <details className="station-rain-details"><summary>Denné hodnoty a zdroje</summary>
        <table><thead><tr><th>Deň</th><th>Zrážky</th><th>Zdroj</th></tr></thead><tbody>
          {daily.map(day => <tr key={day.date}><td>{shortDate(day.date)}</td><td>{rainfallText(day.rain_mm)}</td><td>{day.rain_mm == null ? 'Chýba' : day.source === 'shmu_observed' ? 'Merané SHMÚ' : 'Odhad počasia'}</td></tr>)}
        </tbody></table>
      </details>
    </div>
  )
}
